import type { CueDto } from "@nabla/api";
import { creativeWatchCopy as t } from "./copy.ts";

export const cues = {
  text: (cue: CueDto) => {
    if (cue.code !== "pede-criativos") return undefined;
    return cue.adsets === undefined ? t.pista.conjunto : t.pista.campanha(cue.adsets);
  },
};
